import { Routes, RouterModule } from "@angular/router";
import { DictionariesModule } from "./dictionaries/dictionaries.module";

const routes: Routes = [
  { path: "", redirectTo: "/dashboard", pathMatch: "full" },
  { path: "systemdefinitions", loadChildren: () => DictionariesModule },
  { path: "projecttypes", loadChildren: () => DictionariesModule },
  { path: "individual", loadChildren: () => DictionariesModule },
  { path: "issuetypes", loadChildren: () => DictionariesModule },
  { path: "worklogtypes", loadChildren: () => DictionariesModule },
  { path: "areapaths", loadChildren: () => DictionariesModule },
  { path: "schedulertypes", loadChildren: () => DictionariesModule },
  { path: "funcionalitytypes", loadChildren: () => DictionariesModule },
  { path: "vstsprojects", loadChildren: () => DictionariesModule },
  { path: "erpvstsprojects", loadChildren: () => DictionariesModule },
  { path: "absencetypes", loadChildren: () => DictionariesModule },
  { path: "absencestates", loadChildren: () => DictionariesModule }
];

export const dictionariesRootRouting = RouterModule.forChild(routes);
